module.exports = __webpack_public_path__ + "static/media/builtinv2-potolok.4de4f212.svg";